function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import * as React from 'react';

import LoadingIndicator from './LoadingIndicator';


function makeLoadable(BaseComponent) {
    var LoadableComponent = function LoadableComponent(_ref) {
        var _ref$isLoading = _ref.isLoading,
            isLoading = _ref$isLoading === undefined ? false : _ref$isLoading,
            _ref$loadingIndicator = _ref.loadingIndicatorProps,
            loadingIndicatorProps = _ref$loadingIndicator === undefined ? {} : _ref$loadingIndicator,
            rest = _objectWithoutProperties(_ref, ['isLoading', 'loadingIndicatorProps']);

        return isLoading ? React.createElement(LoadingIndicator, loadingIndicatorProps) : React.createElement(BaseComponent, rest);
    };

    LoadableComponent.propTypes = {
        isLoading: PropTypes.bool,
        loadingIndicatorProps: function loadingIndicatorProps() {
            return (typeof bpfrpt_proptype_LoadingIndicatorProps === 'function' ? bpfrpt_proptype_LoadingIndicatorProps : PropTypes.shape(bpfrpt_proptype_LoadingIndicatorProps)).apply(this, arguments);
        }
    };
    LoadableComponent.displayName = 'Loadable' + (BaseComponent.displayName || BaseComponent.name || 'Component');

    return LoadableComponent;
}

export default makeLoadable;
import { bpfrpt_proptype_Props as bpfrpt_proptype_LoadingIndicatorProps } from './LoadingIndicator';
import PropTypes from 'prop-types';